var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "attendance-event" } }, [
    _c("div", { staticClass: "attendance-img-wrapper" }, [
      _c("div", { staticClass: "apt-image" }),
      _c(
        "div",
        { staticClass: "d-grid" },
        _vm._l(7, function (i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "attendance_wrap",
              class: { seven: i === 7 },
            },
            [
              i === 7
                ? _c("div", { staticClass: "title" }, [_vm._v("7day")])
                : _vm._e(),
              _vm.cnt_attendance < i
                ? _c("img", {
                    attrs: {
                      src: `${_vm.$s3}/img/common/mypage/coupon${_vm.atdcImgNum(
                        i,
                        0
                      )}.svg?${_vm.$ver}`,
                    },
                  })
                : _c("img", {
                    attrs: {
                      src: `${_vm.$s3}/img/common/mypage/coupon${_vm.atdcImgNum(
                        i,
                        0
                      )}_active${_vm.atdcImgNum(i, 1)}.svg?${_vm.$ver}`,
                    },
                  }),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }